<template>
    <div class="transaction-row">
        <div class="transaction-row__header">
            <div class="date">
                {{ date | formatDateTime('Wddmmyy') | capitalize }}
                -
                {{ date | formatDateTime('HHMM') | capitalize }}
            </div>
            <span
                v-if="isAfterCancelStatus"
                class="transaction-row__cancel"
            >
                {{ $t(afterCancelStatus) | capitalize }}
            </span>
            <CustomButton
                v-if="isCancelButtonShown"
                :disabled="isCancelDisabled"
                @click="$emit('cancelWithdrawal', history)"
                class="btn btn--sm btn__flat--secondary transaction-row__cancel"
                :isLoading="showSpinner"
            >
                {{ $t('cancel') | capitalize }}
            </CustomButton>
            <div
                v-if="ticketId"
                @click="$emit('ticketIdClick' , ticketId)"
                class="id"
            >
                {{ ticketId }}
            </div>
        </div>
        <div class="transaction-row__content">
            <div class="transaction-row__description">
                {{ titleDisplay }}
            </div>
            <div class="transaction-row__ammount">
                <span :class="amountClass">
                    {{ amount > 0 ? '+' : '' }}
                    <template v-if="currencyDisplay==='round'">
                        {{ amount | twoDecimals }}
                    </template>
                    <template v-else>
                        {{ amount | twoDecimals(false) }}
                    </template>
                </span>
                <span class="currency">
                    {{ $t('currencyAbbreviation')}}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { TransactionStatus, CancelStatus } from '@models/user/history/History';
    import { capitalize } from '@shared/filters';

    export default {
        name: 'HistoryRow',
        props: {
            history: {
                type: Object,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            date: {
                type: Date,
                required: true
            },
            amount: {
                type: Number,
                required: true
            },
            isCancelable: {
                type: Boolean,
                required: true
            },
            ticketId: {
                type: String,
                required: true
            },
            status: {
                type: String,
                required: true,
            },
            cancelStatus: {
                type: String,
                required: true,
            },
            type: {
                type: Number,
                required: true,
            },
            currencyDisplay: {
                type: String,
                default: 'round', // round or cutoff
            }
        },
        computed: {
            amountClass() {
                const classNames = ['amount'];
                if (this.status === TransactionStatus.cancelled || this.status === TransactionStatus.declined) {
                    classNames.push('amount__cancelled');
                } else if (this.status === TransactionStatus.running) {
                    classNames.push('amount__active');
                } else if (this.status === TransactionStatus.won) {
                    classNames.push('amount__won');
                } else if (this.status === TransactionStatus.lost) {
                    classNames.push('amount__lost');
                } else if (this.status === TransactionStatus.approved) {
                    classNames.push('amount__approved');
                } else {
                    classNames.push('amount__default');
                }
                return classNames;
            },
            showSpinner() {
                return this.cancelStatus === CancelStatus.pending;
            },
            isCancelDisabled() {
                return this.cancelStatus !== CancelStatus.none;
            },
            isCancelButtonShown() {
                return this.isCancelable && [CancelStatus.none, CancelStatus.pending].includes(this.cancelStatus);
            },
            isAfterCancelStatus() {
                return [CancelStatus.success, CancelStatus.failure].includes(this.cancelStatus);
            },
            afterCancelStatus() {
                return this.cancelStatus === CancelStatus.success ? 'canceled' : 'cancellation failed';
            },
            titleDisplay() {
                if (this.title.includes('#BETHISTORYSPORTBET')) {
                    return this.title.replace('#BETHISTORYSPORTBET', capitalize(this.$t('sport')));
                }

                if (this.title.includes('#BETHISTORYLOTOBET')) {
                    return this.title.replace('#BETHISTORYLOTOBET', capitalize(this.$t('lotto')));
                }

                return this.title;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/history/components/HistoryRow.vue